import React, { FC } from 'react';

import CheckListEntryValueSelectWithRoleChecker from '../../../components/moderator/CheckListEntryValueSelectWithRoleChecker';
import ModeratorHallmarksPage from '../ModeratorHallmarksPage';

const ModeratorChecklistPage: FC = () => {
  enum mapping {
    BASIC_DATA = 'basic-data',
    LEGAL_REPRESENTATIVE = 'legal-representative',
    PASSPORT_DATA = 'passport-data',
    VISA = 'visa',
    REGISTRATION_ADDRESS = 'registration-address',
    ACTUAL_ADDRESS = 'actual-address',
    EDUCATIONAL_BACKGROUND = 'educational-background',
    EXAM_RESULT = 'exam-results',
    DIRECTIONS = 'directions',
    TARGET_CONTRACT = 'target-contract',
  }
  const mapToText = new Map<string, string>([
    ['basic-data', 'Основные данные'],
    ['legal-representative', 'Законный представитель'],
    ['passport-data', 'Паспортные данные'],
    ['visa', 'Виза'],
    ['registration-address', 'Адрес постоянной регистрации'],
    ['actual-address', 'Адрес фактического проживания'],
    ['educational-background', 'Сведения об образовании'],
    ['exam-results', 'Результаты ЕГЭ / Расписание ВИ'],
    ['directions', 'Направления поступления'],
    ['target-contract', 'Целевой договор'],
  ]);

  return (
    <div>
      {Object.keys(mapping).map(key => (
        <CheckListEntryValueSelectWithRoleChecker
          size={'minimal'}
          text={mapToText.get(mapping[key])}
          getValue={checkList => checkList.unrelatedCheckMarks[mapping[key]]}
          updateValue={newValue => ({
            unrelatedCheckMarks: {
              [mapping[key]]: newValue,
            },
          })}
        />
      ))}
      <hr />
      <ModeratorHallmarksPage />
    </div>
  );
};

export default ModeratorChecklistPage;
